import Axios from '../../networking/intraceptor';
import { authToken } from '../../storage/authToken';
import { emitRealtimeSocketEvent } from './realtimeSocket';

const EVENTS = {
	connect: 'pharmacy-presence:connect',
	active: 'pharmacy-presence:active',
	idle: 'pharmacy-presence:idle',
	heartbeat: 'pharmacy-presence:heartbeat',
	disconnect: 'pharmacy-presence:disconnect',
};

const ENDPOINTS = {
	connect: 'realtime/presence/connect',
	active: 'realtime/presence/active',
	idle: 'realtime/presence/idle',
	heartbeat: 'realtime/presence/heartbeat',
	disconnect: 'realtime/presence/disconnect',
};

const payloadFor = (connectionId) => ({
	connection_id: connectionId || null,
});

const postPresence = (type, connectionId) => {
	emitRealtimeSocketEvent(EVENTS[type], payloadFor(connectionId));
	return Axios.post(ENDPOINTS[type], payloadFor(connectionId));
};

const buildApiUrl = (endpoint) => {
	const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
	const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

	return new URL(endpoint, normalizedBase).toString();
};

const postPresenceKeepalive = (type, connectionId) => {
	emitRealtimeSocketEvent(EVENTS[type], payloadFor(connectionId));

	const token = authToken();
	if (!token || typeof window.fetch !== 'function') {
		return Promise.resolve();
	}

	return window.fetch(buildApiUrl(ENDPOINTS[type]), {
		method: 'POST',
		keepalive: true,
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(payloadFor(connectionId)),
	}).catch(() => {});
};

export const notifyPresenceConnect = (connectionId) => postPresence('connect', connectionId);
export const notifyPresenceActive = (connectionId) => postPresence('active', connectionId);
export const notifyPresenceIdle = (connectionId) => postPresence('idle', connectionId);
export const notifyPresenceHeartbeat = (connectionId) => postPresence('heartbeat', connectionId);

export const notifyPresenceDisconnect = (connectionId, options = {}) => {
	if (options.keepalive) {
		return postPresenceKeepalive('disconnect', connectionId);
	}

	return postPresence('disconnect', connectionId);
};
